import React from 'react';
import LineItemProductWizard from './LineItemProductWizard';

/**
 * Opportunity line items: delegates to {@link LineItemProductWizard}.
 * Backup of the previous standalone implementation: `OpportunityProductWizard.legacy.js`.
 */
const OpportunityProductWizard = props => (
  <LineItemProductWizard
    lineItemContext="opportunity"
    parentId={props.opportunityId}
    parentCurrency={props.opportunityCurrency}
    initialItems={props.initialItems}
    show={props.show}
    onHide={props.onHide}
    onSaveSuccess={props.onSaveSuccess}
    lineItemWizardConfig={props.lineItemWizardConfig}
  />
);

export default OpportunityProductWizard;
